import { render } from "./BuscaPage.vue?vue&type=template&id=8a261712&scoped=true"
import script from "./BuscaPage.vue?vue&type=script&lang=js"
export * from "./BuscaPage.vue?vue&type=script&lang=js"

import "./BuscaPage.vue?vue&type=style&index=0&id=8a261712&scoped=true&lang=css"

import exportComponent from "C:\\Users\\musta\\Área de Trabalho\\Projetos\\catalogo\\catalogo-pedidos\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a261712"]])

export default __exports__